import type { PlayerRef } from '@xiangqi/protocol';

const VIETNAMESE_NAMES = [
  'Trần Minh Quân',
  'Nguyễn Hoàng Nam',
  'Lê Tuấn Kiệt',
  'Phạm Bảo Long',
  'Vũ Thanh Tùng',
  'Đặng Đức Huy',
  'Bùi Gia Hưng',
  'Đỗ Quang Khải',
  'Ngô Hữu Phước',
  'Hoàng Anh Tuấn',
  'Trịnh Quốc Bảo',
  'Dương Đình Trọng',
  'Lý Hoàng Bách',
  'Mai Tiến Dũng',
  'Hà Khánh Duy',
  'Đinh Hải Đăng',
  'Phan Huy Hoàng',
  'Lương Ngọc Sơn',
  'Võ Trung Kiên',
  'Tạ Minh Triết',
  'Nguyễn Văn Hùng',
  'Trần Đình Trí',
  'Phạm Quốc Toàn',
  'Hoàng Minh Đức',
  'Vũ Văn Nam',
];

const USERNAME_PREFIXES = [
  'minhquan',
  'hoangnam',
  'tuankiet',
  'baolong',
  'thanhtung',
  'duchuy',
  'giahung',
  'quangkhai',
  'anhtuan',
  'quocbao',
  'dinhtrong',
  'hoangbach',
  'tiendung',
  'khanhduy',
  'haidang',
  'huyhoang',
  'ngocson',
  'trungkien',
  'minhtriet',
  'vanhung',
];

export interface SimulatedPlayerProfile {
  userId: string;
  displayName: string;
  username: string;
  rating: number;
  totalGames: number;
  wins: number;
  winRate: number;
}

/**
 * Tạo profile kỳ thủ mô phỏng như người thật.
 * Seed cố định theo matchId hoặc random để thống nhất trong suốt chuỗi ván đấu (tái đấu).
 */
export function generateSimulatedPlayer(seedStr?: string): SimulatedPlayerProfile {
  let hash = 0;
  if (seedStr) {
    for (let i = 0; i < seedStr.length; i += 1) {
      hash = (hash * 31 + seedStr.charCodeAt(i)) >>> 0;
    }
  } else {
    hash = Math.floor(Math.random() * 1_000_000);
  }

  const nameIndex = hash % VIETNAMESE_NAMES.length;
  const displayName = VIETNAMESE_NAMES[nameIndex]!;
  const prefix = USERNAME_PREFIXES[nameIndex % USERNAME_PREFIXES.length]!;
  const suffix = 10 + (hash % 89);
  const username = `${prefix}${suffix}`;
  const rating = 1180 + (hash % 260); // 1180 - 1440
  const totalGames = 25 + (hash % 115); // 25 - 140
  const winRate = 48 + (hash % 16); // 48% - 63%
  const wins = Math.round((totalGames * winRate) / 100);

  return {
    userId: `sim_${hash.toString(16)}`,
    displayName,
    username,
    rating,
    totalGames,
    wins,
    winRate,
  };
}

export function simulatedToPlayerRef(sim: SimulatedPlayerProfile): PlayerRef {
  return {
    user_id: sim.userId,
    display_name: sim.displayName,
    connected: true,
  };
}

/**
 * Giả lập thời gian suy nghĩ của con người (ms).
 * Thay vì đi ngay lập tức (0ms), con người cần 1.2s - 3.5s để nhìn bàn cờ và quyết định.
 */
export function getSimulatedThinkingDelay(ply: number, wasCheckOrCapture = false): number {
  if (wasCheckOrCapture) {
    // Tình huống căng thẳng cần suy nghĩ kỹ hơn
    return 2000 + Math.floor(Math.random() * 1800); // 2.0s - 3.8s
  }
  if (ply < 4) {
    // Khai cuộc quen thuộc
    return 1000 + Math.floor(Math.random() * 1200); // 1.0s - 2.2s
  }
  // Nước đi bình thường
  return 1400 + Math.floor(Math.random() * 1600); // 1.4s - 3.0s
}
